import { Modal, useColorMode } from 'deepstash-ui';
import { reportContentOrUser } from 'api/Insight';
import React, { useState } from 'react';
import { ReportModalConfirmation } from './ReportModalConfirmation';
import { ReportModalInitialBody } from './ReportModalInitialBody';
import { ReportModalText } from './ReportModalText';
import { color } from 'deepstash-ui';
import { EntityReportType, ReportOptionType } from 'types';
import { useIsMobileView } from 'deepstash-ui';
import { Analytics, Events } from 'src/services/analytics';

interface OwnProps {
  isOpen: boolean;
  onClose: () => void;
  type: EntityReportType;
  /**
   * Id of the reported content
   */
  id: number;
  /**
   * Id of owner
   */
  resourceOwner: number;
}

const options = [
  "It's offensive or inappropriate",
  'Inaccurate or misleading information',
  'Nudity or sexual activity',
  'Hate speech',
  'Something else',
];

export const ReportModal: React.FC<OwnProps> = ({
  isOpen,
  onClose,
  id,
  resourceOwner,
  type,
}) => {
  const { colorMode } = useColorMode();
  const isMobileView = useIsMobileView();
  const [selectedOption, setSelectedOption] = useState<
    ReportOptionType | undefined
  >();

  const [isDone, setIsDone] = useState(false);

  const handleReport = async (reportType: string) => {
    try {
      await reportContentOrUser({
        type,
        id,
        resource_owner: resourceOwner,
        reason: reportType,
      });
      Analytics.logEvent({
        eventName: Events.social.reportContentOrUser,
        properties: {
          type: type,
          reason: reportType,
        },
        platforms: ['amplitude'],
      });
      setIsDone(true);
    } catch (error) {
      setIsDone(false);
    }
  };

  const handleClose = () => {
    if (!isDone) {
      setSelectedOption(undefined);
    }
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      backgroundColor={color[colorMode].surface}
      borderRadius="20px"
      p="16px"
      minWidth={isMobileView ? '300px' : '475px'}
      width={isMobileView ? 'calc(100% - 1rem)' : '40%'}
      modalBodyProps={{
        px: '0.25rem',
      }}
      color={color[colorMode].text}
    >
      {!selectedOption ? (
        <ReportModalInitialBody
          options={options}
          setSelectedOption={setSelectedOption}
          handleReport={handleReport}
        />
      ) : selectedOption === 'Something else' && !isDone ? (
        <ReportModalText handleReport={handleReport} />
      ) : (
        <ReportModalConfirmation />
      )}
    </Modal>
  );
};

export default ReportModal;
